/**
 * @file 封装请求数据接口
 * @author quda
 */
import jsonp from '@/common/utils/jsonp.js';
import common from '@/common/utils/com.js';
import Const from './constant/Constant';

export default (url, reqParams = {}) => {
    if (!url) {
        throw new Error('[Error] request url is required!');
    }
    // 接口path
    let addressUrl = Const.dataUrl;
    const urlParams = common.getParamsFromUrl();
    // 接入昊天镜参数
    const params = {
        // cuid: window.yymap.nativeAppAdapter.phoneinfo.cuid || '',
        // zid: window.yymap.nativeAppAdapter.phoneinfo.zid || '',
        // fr: urlParams.fr || 'default',
        // os: urlParams.os || window.yymap.nativeAppAdapter.phoneinfo.os || '',
        // sv: urlParams.sv || window.yymap.nativeAppAdapter.phoneinfo.sv || '',
        // to: window.xaf.getData().Token,
        // vw: window.xaf.getData().view
    };
    Object.assign(reqParams, params);
    return jsonp(addressUrl[url], reqParams);
};
